import React, { useEffect, useState } from 'react';
import { murmurhash } from '../../../../../lib/js/hash';

// Components
import FormInput from '../FormInput/FormInput';

// Enumerables
import extendClassNameWithModifier from '../../../../../lib/bemUtils/bem';
import { FormInputModifier } from '../FormInput/FormInput.modifier';
import { InputType } from '../../InputTypes';

// Enumerable
export enum FormDateTimeModifier {
  FULL_WIDTH = 'form-date-time--fullwidth',
}

export const getDateRangeValue = (
  value: string,
  dateTimeLocal: string | undefined,
  isAllDay: boolean,
): string | undefined => {
  if (isAllDay) {
    return dateTimeLocal ? dateTimeLocal.split('T')[0] : value;
  }
  return dateTimeLocal;
};

type FormDateTimeType = {
  modifier?: FormDateTimeModifier | FormDateTimeModifier[];
  modifierInput?: FormInputModifier;
  label: string;
  labelHelpText?: string;
  name: string;
  required?: boolean;
  value?: string;
  min?: string;
  max?: string;
  validationMessageMapper?: {
    issuer?: string;
    message?: string;
  };
  isAllDay?: boolean;
  // Events
  onChange?: (event: any) => void;
  onBlur?: any;
};

export default function FormDateTime({
  modifier,
  modifierInput,
  label,
  labelHelpText = '',
  name,
  required = false,
  value,
  min,
  max,
  validationMessageMapper = {},
  isAllDay = true,
  onChange,
  onBlur = () => {},
}: FormDateTimeType) {
  const [dateTimeLocal, setDateTimeLocal] = useState(value && value.includes('T') ? value : undefined);

  /**
   * We store datetime-local in state because from datetime-local we
   * built date. If it is lost, caused incorrect behavior of the date picker.
   * */
  useEffect(() => {
    if (isAllDay && value && value.includes('T')) {
      setDateTimeLocal(value);
    }
  }, [isAllDay, value]);

  const getValidationMessageForField = (nameParam: string) => {
    if (validationMessageMapper?.issuer && nameParam.includes(validationMessageMapper.issuer)) {
      return validationMessageMapper.message;
    }
    return '';
  };

  const portalId = murmurhash(name + label + isAllDay);
  return (
    <div className={extendClassNameWithModifier('form-date-time', modifier)}>
      <div className="form-date-time__row">
        <div className="form-date-time__grid form-date-time__grid--date">
          <FormInput
            // new key -> new mount -> changing type on the fly with different values throws warnings
            key={portalId}
            labelTitle={label}
            labelHelpText={labelHelpText}
            id={portalId}
            type={isAllDay ? InputType.DATE : InputType.DATETIME_LOCAL}
            name={name}
            required={required}
            value={value && getDateRangeValue(value, dateTimeLocal, isAllDay)}
            validationMessage={getValidationMessageForField(name)}
            // Event
            onChange={onChange}
            onBlur={onBlur}
            modifierInput={modifierInput}
            min={min}
            max={max}
          />
        </div>
      </div>
    </div>
  );
}
